import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=58cdb7bd&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58cdb7bd')) {
      api.createRecord('58cdb7bd', component.options)
    } else {
      api.reload('58cdb7bd', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=58cdb7bd&", function () {
      api.rerender('58cdb7bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2NM3SQIhSLGqT/JS/pricehelp.vue"
export default component.exports